<!-- компонент: калькулятор -->
<template>
	<div v-show="dialogVisible" @click="hideDialog" class="modal-mask">
		<div class="modal-wrapper">
			<div v-show="!showList" class="modal-container calc-form" @click.stop>

				<div class="modal-header">
					<span class="font-weight-500">{{ 'service/calculator' | ftc }}</span>
					<button type="button" class="close" @click="hideDialog">&times;</button>
				</div>

				<div class="modal-body for-calc">
					<form class="w5-from">
						<fieldset class="position-relative">
							<div v-if="serviceField" class="w5-form-row">
								<p v-if="serviceField.list && serviceField.list.length" class="description" v-withSafeTags="localeFtc('service/calculator_description')"></p>
								<div v-else class="text-center">
									<img src="../../assets/img/puzzle.png" class="w5-empty-table-img" />
									<br>
									<span class="font-size-110 w5-empty-table-hint">{{ 'main/empty_table' | ftc }}</span>
								</div>
							</div>
							<div v-if="serviceField && serviceField.list && serviceField.list.length && serviceField.groupsMap && serviceField.groupsMap.size" class="w5-form-row services">
								<div v-for="(service, idx) in serviceField.groupsMap.entries()" :key="idx" class="service-item">
									<div class="step-number"><span class="step-number-block">{{ idx + 1 }}</span><strong>{{ groupNames[service[0]] | ftc }}</strong></div>
									<div class="services-list">
										<template v-if="service && service[1] && service[1].list && service[1].list.length <= showServicesCount">
											<div v-for="(item, idx) in service[1].list" :key="idx" class="services-list-item" :class="{ noprolong: !item.autoprolong }">
												{{ item.name | ftc }} &rarr; {{ rounding(item.cost) }} <span v-withSafeTags="localeFtc('main/ruble')"></span> / {{ item.period_name | ftc }}
												<notice v-if="!item.autoprolong" :text="'service/calculator_notice' | ftc" :small="true" style="margin-left: 5px" />
											</div>
										</template>
										<template v-else>
											<div v-for="(item, idx) in service[1].list" :key="idx" v-if="idx <= (showServicesCount - 1)" class="services-list-item" :class="{ noprolong: !item.autoprolong }">
												{{ item.name | ftc }} &rarr; {{ rounding(item.cost) }} <span v-withSafeTags="localeFtc('main/ruble')"></span> / {{ item.period_name | ftc }}
												<notice v-if="!item.autoprolong" :text="'service/calculator_notice' | ftc" :small="true" style="margin-left: 5px" />
											</div>
											<div class="cutter" @click="showCutted(idx, groupNames[service[0]], service[1].list)">{{ 'calc/and_more' | ftc }} {{ service[1].list.length - showServicesCount }}...</div>
										</template>
									</div>
								</div>
							</div>
						</fieldset>
					</form>
				</div>

				<div v-if="serviceField && serviceField.list && serviceField.list.length" class="modal-footer calculator">
					<div class="w5-form-row calc-value">
						<img v-if="isLoading" src="../../assets/img/loading-hor16.gif" />
						<span v-else-if="errorMessage" class="error">{{ errorMessage | ftc }}</span>
						<span v-else><strong>{{ 'plan/cost' | ftc }}: {{ rounding(calcValue) }} <span v-withSafeTags="localeFtc('main/ruble')"></span></strong></span>
					</div>
					<div class="w5-form-row period">
						<Field
							crud="service"
							action="calc"
							v-model="periodField.value"
							:isVisibleRow="true"
							:Field="periodField"
							:removeRightPadding="true"
							:fieldInModal="true"
							@valueChanged="fieldChanged" />
					</div>
					<span class="btn btn-submit" :disabled="errorMessage || calcValue === '0.00' || !calcValue ? 'disabled' : false" @click="topupBalance">{{ 'bonus/rule_replenishment' | ftc }}</span>
				</div>
			</div>

			<div v-show="showList" class="modal-container calc-form" @click.stop>

				<div class="modal-header">
					<span class="font-weight-500">{{ 'service/calculator' | ftc }}</span>
					<button type="button" class="close" @click="showList = false">&larr;</button>
				</div>

				<div class="modal-body show-list">

					<div class="services-list shown">
						<div class="step-number"><span class="step-number-block">{{ showList.n + 1 }}</span><strong>{{ showList.name | ftc }}</strong></div>
						<div v-for="(item, idx) in showList.list" :key="idx" class="services-list-item" :class="{ noprolong: !item.autoprolong }">
							<strong>&bull;</strong> {{ item.name }} &rarr; <strong>{{ rounding(item.cost) }} <span v-withSafeTags="localeFtc('main/ruble')"></span> / {{ item.period_name }}</strong>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
///////////////////////////////////////////////////////////////////////////////
import Vue from 'vue'
import Helper from '@/helper/helper'
import mixinLoader from '@/mixins/loader'
import Field from '@/components/elements/formfield'
import notice from '@/components/elements/notice'
import { EventBus } from '@/bus.js'
///////////////////////////////////////////////////////////////////////////////
export default {
	//=========================================================================
	// наименование
	//=========================================================================
	name: 'dialogCalc',
	mixins: [mixinLoader],

	//=========================================================================
	// свойства переданные родителем
	//=========================================================================
	props: {
		visible: {
			type: Boolean,
			required: true
		}
	},

	//=========================================================================
	// вычисляемые свойства компонента
	//=========================================================================
	computed: {
		showServicesCount() {
			return 3
		}
	},

	//=========================================================================
	// свойства компонента
	//=========================================================================
	data() {
		return {
			dialogVisible: this.visible,
			calcValue: '0.00',
			errorMessage: '',
			periodField: null,
			serviceField: null,
			model: '',
			csrf: '',
			showList: false,

			groupNames: {
				[Vue.Constants.SERVICE_TYPE_VDS]: 'menu/vds',
				[Vue.Constants.SERVICE_TYPE_VDS_IP4]: 'service/ip4_count',
				[Vue.Constants.SERVICE_TYPE_VDS_IP6]: 'service/ip6_count',
				[Vue.Constants.SERVICE_TYPE_VDS_RAM]: 'service/ram',
				[Vue.Constants.SERVICE_TYPE_VDS_SSD]: 'service/ssd',
				[Vue.Constants.SERVICE_TYPE_VDS_CPU]: 'CPU',
				[Vue.Constants.SERVICE_TYPE_VDS_TRAFF]: 'TRAFF',
				[Vue.Constants.SERVICE_TYPE_VDS_LOAD]: 'server/load_min',
				[Vue.Constants.SERVICE_TYPE_VDS_SNAPSHOT]: 'SNAPSHOT',
				[Vue.Constants.SERVICE_TYPE_ISO]: 'service/iso',
				[Vue.Constants.SERVICE_TYPE_SSL]: 'menu/certificate_ssl',
				[Vue.Constants.SERVICE_TYPE_DOMAIN]: 'main/domains',
				[Vue.Constants.SERVICE_TYPE_DOMAIN_PRIVACY]: 'PRIVACY',
				[Vue.Constants.SERVICE_TYPE_DNS]: 'menu/dns',
				[Vue.Constants.SERVICE_TYPE_BACKUP_VDS]: 'service/backups'
			}
		}
	},

	//=========================================================================
	// компонент создан
	//=========================================================================
	beforeCreate() {
		this.$http.get(Vue.APIServerUrl + '/servicetype/get')
		.then(res => {
			let _dt = res && res.data && typeof res.data === 'object' ? res.data : false
			if (_dt && _dt.status === 'ok' && _dt.result && _dt.result.length)
			{
				_dt.result.forEach(item => {
					if (item && item.id)
						this.groupNames[item.id] = item.name
				})
			}
		})
		.catch(() => {})
	},

	//=========================================================================
	// методы компонента
	//=========================================================================
	methods: {
		// округление
		rounding(val) {
			let r = parseFloat(val)
			if (isNaN(r)) return val
			return r.toFixed(2)
		},
		// инициализация события "onClose" - закрыть диалог
		hideDialog() {
			this.$emit('onClose')
		},
		// запрос списка услуг
		requestFields() {
			this.$http.get(Vue.APIServerUrl + '/service/calc')
			.then(res => {
				let _dt = res && res.data && typeof res.data === 'object' ? res.data : false

				if (_dt && _dt.status === 'form' && _dt.model && _dt.fields && typeof _dt.fields === 'object')
				{
					this.model = _dt.model
					this.csrf = _dt._csrf

					for (let prop in _dt.fields)
					{
						if (prop === 'period' && _dt.fields[prop] && _dt.fields[prop].list)
						{
							this.periodField = Object.assign({ value: null, _visible: true, _field_name: prop }, _dt.fields[prop], { list: [] })
							for (let id in _dt.fields[prop].list)
							{
								this.periodField.list.push({ id, name: _dt.fields[prop].list[id] })
								if (_dt.fields[prop].value === id)
								{
									this.periodField.value = id
									EventBus.$emit('w5-set-list-field-value', {
										name: 'period',
										value: { id, name: _dt.fields[prop].list[id] }
									})
								}
							}

							if (!this.periodField.value)
							{
								this.periodField.value = this.periodField.list[0].id
								EventBus.$emit('w5-set-list-field-value', {
									name: 'period',
									value: this.periodField.list[0]
								})
							}
						}
						else if (prop === 'service_id' && _dt.fields[prop] && _dt.fields[prop].list)
						{
							this.serviceField = Object.assign({}, _dt.fields[prop])
							this.compileServices()
						}
					}

					this.fieldChanged()
				}
			})
		},
		// обработчик: изменилось значение
		fieldChanged() {
			this.errorMessage = ''

			if (!this.periodField) return

			let _post = { '_csrf': '' }
			_post[this.model] = {
				'period': this.periodField.value
			}

			let _url = Vue.APIServerUrl + '/service/calc'
			this.setLoader(true)

			if (this.csrf)
			{
				_post._csrf = this.csrf
				this.$http.post(_url, Helper.toFormData(_post))
				.then(resPost => {
					this.setLoader(false)
					let _dt = resPost && resPost.data && typeof resPost.data === 'object' ? resPost.data : false
					// если ошибки нет
					if (_dt && _dt['status'] === 'ok' && _dt.result && typeof _dt.result === 'object' && 'summa' in _dt.result)
					{
						this.calcValue = (_dt.result.summa).toFixed(2)
						// на это все
						return
					}

					throw resPost
				})
				.catch(error => {
					this.calcValue = '0.00'
					this.setLoader(false)

					this.errorMessage = this.localeFtc('main/error_desc').replace(':', '')
					if (error && error.message) this.errorMessage = error.message
					if (error && error.content) this.errorMessage = error.content
				})

				return
			}

			this.$http.get(_url)
			.then(res => {
				let _dt = res && res.data && typeof res.data === 'object' ? res.data : false

				if (_dt && _dt.status === 'form' && _dt._csrf)
				{
					_post._csrf = _dt._csrf
					this.$http.post(_url, Helper.toFormData(_post))
					.then(resPost => {
						this.setLoader(false)
						_dt = resPost && resPost.data && typeof resPost.data === 'object' ? resPost.data : false
						// если ошибки нет
						if (_dt && _dt['status'] === 'ok' && _dt.result && typeof _dt.result === 'object' && 'summa' in _dt.result)
						{
							this.calcValue = (_dt.result.summa).toFixed(2)
							// на это все
							return
						}

						throw resPost
					})
					.catch(error => {
						this.calcValue = '0.00'
						this.setLoader(false)

						this.errorMessage = this.localeFtc('main/error_desc').replace(':', '')
						if (error && error.message) this.errorMessage = error.message
						if (error && error.content) this.errorMessage = error.content
					})

					return
				}

				throw _dt
			})
			.catch(error => {
				this.calcValue = '0.00'
				this.setLoader(false)

				this.errorMessage = this.localeFtc('main/error_desc').replace(':', '')
				if (error && error.message) this.errorMessage = error.message
				if (error && error.content) this.errorMessage = error.content
			})
		},
		// сборка услуг с группировкой по группе "st_id"
		compileServices() {
			if (!this.serviceField || !this.serviceField.list || !this.serviceField.list.length)
				return

			let groupsMap = new Map()
			this.serviceField.list.forEach(service => {
				if (service && service.id && service.st_id)
				{
					let services = groupsMap.get(service.st_id)
					if (services && services.list)
					{
						services.selected = this.serviceField.value && this.serviceField.value.length ? this.serviceField.value.indexOf(service.id) > -1 : false
						services.list.push(service)
					}
					else
					{
						services = {
							selected: this.serviceField.value && this.serviceField.value.length ? this.serviceField.value.indexOf(service.id) > -1 : false,
							list: [service]
						}
						groupsMap.set(service.st_id, services)
					}
				}
			})

			this.serviceField.groupsMap = groupsMap
		},
		// клик по службе
		serviceClick(id) {
			if (!this.serviceField || !this.serviceField.list || !this.serviceField.groupsMap)
				return

			let services = this.serviceField.groupsMap.get(id)
			services.selected = !services.selected
			this.$forceUpdate()
			this.fieldChanged()
		},
		// пополнение
		topupBalance() {
			if (this.errorMessage || this.calcValue === '0.00' || !this.calcValue)
				return

			this.$store.commit('setOperationSumNew', this.calcValue)
			this.$router.push('/operation/create')
		},
		//
		showCutted(n, name, list) {
			if (!list || !list.length)
				return

			this.showList = { n, name, list }
		}
	},

	//=========================================================================
	// наблюдаем за свойствами
	//=========================================================================
	watch: {
		visible: {
			handler: function(visible) {
				if (visible)
					this.requestFields()

				this.dialogVisible = visible
				if (this.periodField && this.periodField.list && this.periodField.list.length)
				{
					this.periodField.value = this.periodField.list[0].id
					EventBus.$emit('w5-set-list-field-value', {
						name: 'period',
						value: this.periodField.list[0]
					})
				}
				this.errorMessage = ''
				this.calcValue = '0.00'
			},
			immediate: true
		}
	},

	//=========================================================================
	// компоненты
	//=========================================================================
	components: {
		notice,
		Field
	}

	//=========================================================================
}
///////////////////////////////////////////////////////////////////////////////
</script>

<style scoped>
.modal-container.calc-form {
	width: 95% !important;
	max-width: 660px;
	/*overflow: auto;*/
}

/*
@media screen and (max-height: 731px) {
	.modal-container.calc-form {
		max-height: calc(100% - 2px);
	}
}
@media screen and (max-height: 667px) {
	.modal-wrapper {
    	vertical-align: top;
	}
	.modal-container.calc-form {
		max-height: calc(100% - 19px);
	}
}
@media screen and (max-height: 640px) {
	.modal-container.calc-form {
		max-height: calc(100% - 63px);
	}
}
@media screen and (max-height: 568px) {
	.modal-container.calc-form {
		max-height: calc(100% - 189px);
	}
}
*/

.modal-container.calc-form .modal-body {
	min-height: 220px;
}

.modal-container.calc-form .modal-body.show-list {
	display: flex;
	display: -webkit-box;
	display: -webkit-flex;
	justify-content: flex-start;
	-webkit-justify-content: flex-start;
	align-items: center;
	-webkit-align-items: center;
	min-height: 100px;
	padding: 15px;
}

.w5-form-row p.description {
	margin: 10px 0 20px;
}
.w5-form-row div.text-center {
	display: inline-block;
	margin: 20px auto;
}

.w5-form-row.services {
	display: block;
}

.service-item {
	position: relative;
	display: block;
	font-size: 16px;
	font-weight: 500;
	margin-bottom: 20px;
}

.service-item .step-number {
	display: block;
	position: unset;
	color: #333;
}

.services-list {
	margin-left: 41px;
}

.services-list .cutter {
	display: inline-block;
	font-size: 12px;
	font-weight: 300;
	color: #2880da;
	border-bottom: dashed 1px #2880da;
	cursor: pointer;
}
.w5-application.mc .services-list .cutter {
	color: #3250ba;
	border-bottom: dashed 1px #3250ba;
}

.services-list.shown {
	position: relative;
	margin-left: 15px;
}

.services-list.shown .step-number {
    position: unset;
	margin-bottom: 20px;
}

.services-list-item {
	font-size: 13px;
	font-weight: 400;
}

.services-list-item.noprolong {
	color: #ccc
}

.modal-footer.calculator {
	display: flex;
	display: -webkit-box;
	display: -webkit-flex;

	justify-content: space-between;
	-webkit-justify-content: space-between;

	align-items: center;
	-webkit-align-items: center;

	text-align: left;
	padding: 5px 15px;
}

.modal-footer.calculator:before,
.modal-footer.calculator:after {
	display: none;
	content: ''
}

.modal-footer.calculator .w5-form-row.calc-value {
	display: flex;
	display: -webkit-box;
	display: -webkit-flex;
	align-items: center;
	-webkit-align-items: center;

	margin-right: 15px;
	height: 48px;
    font-size: 14px;
    color: #555;
	line-height: 1;
	flex: 3 0 0;
}

.modal-footer.calculator .w5-form-row.calc-value > .error {
	color: red
}

.modal-footer.calculator .w5-form-row.period {
	flex: 1 0 200px;
	margin-right: 15px;
}

.modal-footer.calculator .btn {
	flex: 1 0 0;
}

@media screen and (max-width: 767px) {
	.modal-footer.calculator {
		flex-direction: column;
	}
	.modal-footer.calculator .w5-form-row.calc-value {
		width: 100%;
		margin: 0;
		flex: 1;
		line-height: 24px;
		height: 24px;
	}
	.modal-footer.calculator .w5-form-row.period {
		flex: 1;
		margin: 0;
	}
	.modal-footer.calculator .btn {
		margin: 10px 0;
		flex: 1;
	}
}

</style>



// WEBPACK FOOTER //
// calc.vue?4a5f6e1a